<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <vue-topprogress :zIndex="999999999999999" ref="topProgress" color="#358fe8" :trickleSpeed="200" />
    <side-bar>
      <template slot-scope="props" slot="links">

        <!-- General Routes Top -->
        <sidebar-item                    :link="{name: $ml.get('account'),         icon: 'now-ui-icons users_circle-08',       path: 'account'}"> </sidebar-item>
        <!-- General Routes Bottom -->

        <!-- Begin Admin and Client Sidebar -->

        <!-- evid.at
        <sidebar-item  v-if="company.config && company.config.using_evid || (account.role === 'admin')"                  :link="{name: $ml.get('guest_checkin'),         icon: 'now-ui-icons files_single-copy-04',       path: 'covid'}"> </sidebar-item>
        -->
        <!-- WiFi -->
        <sidebar-item v-if="!!company.config && company.config.using_wifi || (account.role === 'admin')"  :link="{name: 'wifi', icon: 'fa fa-wifi'}">
          <sidebar-item   :link="{name: $ml.get('statistics'),      icon: 'now-ui-icons business_chart-bar-32', path: 'wifi-statistics'}"> </sidebar-item>
          <sidebar-item   :link="{name: 'Hotspot',                  icon: 'now-ui-icons tech_mobile',           path: 'configuration'}"> </sidebar-item>
          <sidebar-item v-if="hasRegistration || account.role === 'admin'"  :link="{name: $ml.get('guests'),           icon: 'now-ui-icons users_single-02',       path: 'guests'}"> </sidebar-item>
          <sidebar-item v-if="hasRegistration || account.role === 'admin'"  :link="{name: $ml.get('message_service'),  icon: 'now-ui-icons ui-1_email-85',         path: 'message'}"> </sidebar-item>
          <sidebar-item   :link="{name: $ml.get('wifi_posts'),      icon: 'fa fa-bullhorn',                         path: 'wifi-posts'}"> </sidebar-item>
          <sidebar-item   :link="{name: $ml.get('aps'),             icon: 'now-ui-icons location_compass-05',   path: 'aps'}"> </sidebar-item>
          <!--
          <sidebar-item   :link="{name: $ml.get('package'),        icon: 'now-ui-icons shopping_box',          path: 'package'}"> </sidebar-item>
          -->
        </sidebar-item>

        <sidebar-item :link="{name: $ml.get('gallery'),         icon: 'now-ui-icons design_image',          path: 'gallery'}"> </sidebar-item>

        <!--
        <sidebar-item v-if="showBillboard || account.role === 'admin'"  :link="{name: $ml.get('billboard_posts'),    icon: 'now-ui-icons tech_tv',               path: 'billboard-posts'}"> </sidebar-item>
        -->

        <sidebar-item v-if="!!company.config && company.config.using_wifi || (account.role === 'admin')"  :link="{name: $ml.get('reviews'),         icon: 'fa fa-star',                         path: 'reviews'}"> </sidebar-item>

        <!--
        <sidebar-item v-if="!!company.config && company.config.using_gift || (account.role === 'admin')"                                 :link="{name: $ml.get('gifts'),           icon: 'fa fa-gift',                         path: 'gift'}"> </sidebar-item>
        -->

        <!-- Billing 
        <sidebar-item :link="{name: $ml.get('billing'),           icon: 'now-ui-icons education_paper'}">
          <sidebar-item :link="{name: $ml.get('invoices'),        icon: 'now-ui-icons education_paper',       path: 'invoices'}"> </sidebar-item>
          <sidebar-item :link="{name: $ml.get('credit'),          icon: 'now-ui-icons shopping_cart-simple', path: 'credit'}"> </sidebar-item>
        </sidebar-item>
        -->

        <!-- Begin Admin only -->
        <sidebar-item v-if="account.role === 'admin'"                               :link="{name: $ml.get('companies'),       icon: 'now-ui-icons design_vector',         path: 'companies'}"> </sidebar-item>
        <!--
        <sidebar-item v-if="account.role === 'admin'"                               :link="{name: $ml.get('urls'),            icon: 'now-ui-icons design-2_html5',        path: 'urls'}"> </sidebar-item>
        -->
        <sidebar-item v-if="account.role === 'admin'"                               :link="{name: $ml.get('accounts'),        icon: 'now-ui-icons users_circle-08',       path: 'accounts'}"> </sidebar-item>
        <sidebar-item v-if="account.role === 'admin'"                               :link="{name: $ml.get('bulk_requests'),   icon: 'now-ui-icons ui-1_email-85',         path: 'bulk-requests'}"> </sidebar-item>
        <!-- End Admin only -->

        <!-- Begin Reseller Sidebar -->
        <sidebar-item v-if="account.role === 'reseller'"                            :link="{name: $ml.get('statistics'),      icon: 'now-ui-icons business_chart-bar-32', path: 'statistics'}"> </sidebar-item>
        <sidebar-item v-if="account.role === 'reseller'"                            :link="{name: $ml.get('clients'),         icon: 'now-ui-icons users_single-02',       path: 'clients'}"> </sidebar-item>
        <sidebar-item v-if="account.role === 'reseller'"                            :link="{name: $ml.get('new_client'),         icon: 'now-ui-icons ui-1_zoom-bold',       path: 'client-form'}"> </sidebar-item>
        <sidebar-item v-if="account.role === 'reseller' && !!account.reseller.payload.technical"                            :link="{name: $ml.get('devices'),         icon: 'now-ui-icons tech_laptop',           path: 'devices'}"> </sidebar-item>
        <!-- End Reseller Sidebar -->

        <!-- General Routes Bottom -->
        <sidebar-item                                         :link="{name: $ml.get('contact'),         icon: 'now-ui-icons ui-2_chat-round',       path: 'contact'}"> </sidebar-item>
        <sidebar-item v-if="false"                            :link="{name: $ml.get('help'),            icon: 'now-ui-icons objects_support-17',    path: 'help'}"> </sidebar-item>
        <!-- General Routes Bottom -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar> </top-navbar>
      <router-view name="header"> </router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view> </router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"> </content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'
  import { mapGetters, mapActions } from 'vuex'

  function hasElement (className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar (className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions'
  import { vueTopprogress } from 'vue-top-progress';

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      SlideYDownTransition,
      ZoomCenterTransition,
      vueTopprogress
    },
    computed: {
      ...mapGetters(['hasRegistration', 'showBillboard'])
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    mounted () {
      this.$refs.topProgress.start();
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on')
      } else {
        docClasses.add('perfect-scrollbar-off')
      }
    },
    watch: {
      account() {
        this.$forceUpdate();
      },
      globalLoading(nv) {
        if (nv) {
          this.$refs.topProgress.start();
        } else this.$refs.topProgress.done();

      }
    }
  }

</script>
<style lang="scss">
  $scaleSize: .95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
